import { createFileRoute } from "@tanstack/react-router";

import { FeatureTogglesPage } from "../../pages/settings/FeatureToggles.page";

// `settings_` keeps this route out of the `/settings` layout (see the
// Integration Keys route beside it).
export const Route = createFileRoute("/_protected/settings_/feature-toggles")({
  component: FeatureTogglesPage,
});
